import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { KYCStatus } from "@funded-here-interface/common/src/constant/enum";

type UpdateKycRequest = {
  token: string;
  kycStatus: KYCStatus;
  orgRoleId: number;
};

const updateKyc = async ({ token, kycStatus, orgRoleId }: UpdateKycRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization/kyc-update`,
      { kycStatus, orgRoleId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default updateKyc;
